import React, { useEffect } from "react";
import { FaMapMarkerAlt, FaClock } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import "../sell-fast-page/info-page.css";
import { EMAIL } from "../../../configs/website-information/websiteInfo";

const CHANNELS = [
  {
    icon: <MdEmail size={22} color="#ed1b24" />,
    title: "Email",
    lines: [
      { label: "General enquiries", value: EMAIL, href: `mailto:${EMAIL}` },
    ],
  },
  {
    icon: <FaClock size={22} color="#ed1b24" />,
    title: "Support Hours",
    lines: [
      { label: "Mon – Fri", value: "9:00 am – 6:00 pm", href: null },
      { label: "Sat – Sun", value: "8:00 am – 5:00 pm", href: null },
    ],
  },
];

function ContactUsPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="info-page">
      <div className="container">
        <div className="info-page__card">

          <div className="info-page__hero">
            <p className="info-page__eyebrow">Get in Touch</p>
            <h1 className="info-page__title">Contact Us</h1>
            <p className="info-page__subtitle">
              We're here to help. Reach our team by email during business hours.
            </p>
          </div>

          <div className="info-page__body">
            <div className="row g-3">
              {CHANNELS.map((ch, i) => (
                <div key={i} className="col-sm-12 col-md-6">
                  <div className="info-section" style={{ height: "100%" }}>
                    <div className="info-section__icon-wrap">{ch.icon}</div>
                    <div className="info-section__content">
                      <h3 className="info-section__title">{ch.title}</h3>
                      {ch.lines.map((line, j) => (
                        <div key={j} style={{ marginBottom: "0.25rem" }}>
                          <span style={{ fontSize: "0.8rem", color: "#94a3b8" }}>{line.label}</span><br />
                          {line.href ? (
                            <a href={line.href} target={line.href.startsWith("https") ? "_blank" : undefined} rel="noreferrer"
                              style={{ fontSize: "1rem", fontWeight: 700, color: "#1e293b", textDecoration: "none" }}
                              onMouseEnter={e => (e.currentTarget.style.color = "#ed1b24")}
                              onMouseLeave={e => (e.currentTarget.style.color = "#1e293b")}
                            >
                              {line.value}
                            </a>
                          ) : (
                            <span style={{ fontSize: "1rem", fontWeight: 700, color: "#1e293b" }}>{line.value}</span>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="info-section" style={{ flexDirection: "column", gap: "0.5rem", background: "#fafafa" }}>
              <div style={{ display: "flex", alignItems: "flex-start", gap: "0.75rem" }}>
                <FaMapMarkerAlt size={18} color="#ed1b24" style={{ marginTop: 3, flexShrink: 0 }} />
                <div>
                  <h3 className="info-section__title" style={{ marginBottom: "0.25rem" }}>Based in Sri Lanka</h3>
                  <p style={{ fontSize: "0.9rem", color: "#475569", margin: 0, lineHeight: 1.6 }}>
                    AdsOne.lk is Sri Lanka's dedicated vehicle classifieds marketplace, serving buyers and sellers island-wide. All support is handled locally by our Sri Lankan team.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="info-page__cta">
            <h3>Can't find what you need?</h3>
            <p>Check our FAQ for answers to the most common questions about buying and selling on AdsOne.</p>
          </div>

        </div>
      </div>
    </div>
  );
}

export default ContactUsPage;
